import { Box, Typography } from '@mui/material';

const STEPS = {
  1: 'Includes creating a project in DaVinci, linking SOW, set up the budget, and defining the team structure.',
  2: 'Includes creating a project in Redmine, set up Teams, SharePoint, Git, and 1Password.',
};

const ProjectFormHeader = ({ steps = STEPS, currentStep }: { steps?: Record<number, string>; currentStep: number }) => {
  const maxStepNumber = Math.max(...(Object.keys(steps) || []).map(Number), 0);

  return (
    <>
      <Box sx={{ alignItems: 'center', display: 'flex', gap: 4, flexDirection: 'row', pb: 2 }}>
        <Typography variant="h1" color="brand" pl={1}>
          Project Setup
        </Typography>
        <Typography variant="body1" color="textSecondary">
          Step {currentStep} of {maxStepNumber}
        </Typography>
      </Box>
      <Typography variant="body1" color="textSecondary" pb={4} pl={1}>
        {steps[currentStep]}
      </Typography>
    </>
  );
};

export default ProjectFormHeader;
